import { useState, useEffect } from 'react';
import { Select, theme, Space, Button, Input, DatePicker, App } from 'antd';
import { ProTable } from '@ant-design/pro-components';
import {
    useGetPayableInvoicesQuery,
    useHoldPayableInvoiceMutation,
    useReleasePayableInvoiceMutation,
    useDownloadPayableInvoicesMutation,
} from '../../features/api/apiSlice';
import PayableManagementLogModal from './PayableManagementLogModal';
import MakePaymentModal from './MakePaymentModal';
import MakePaymentThroughSearchModal from './MakePaymentThroughSearchModal';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { renderDate } from '../utils';
import "./PayableManagementPage.css"
const { RangePicker } = DatePicker;
function PayableManagementPage() {
    const { token } = theme.useToken();
    const [searchData, setSearchData] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const { data, isLoading, isFetching, refetch } = useGetPayableInvoicesQuery(searchData);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalData, setLogModalData] = useState(false);
    const [logModalLoading, setLogModalLoading] = useState(true);
    const [loadingRecordId, setLoadingRecordId] = useState(null);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [paymentModalData, setPaymentModalData] = useState(false);
    const [paymentThroughSearchModalOpen, setPaymentThroughSearchModalOpen] = useState(false);
    const [paymentThroughSearchModalData, setPaymentThroughSearchModalData] = useState(false);
    const { notification } = App.useApp();
    const currUser = useSelector((state) => state.auth.user);
    const [holdPayableInvoice, {
        isLoading: isHolding,
        isSuccess: isHoldSuccess,
        isError: isHoldError,
        error: holdError,
    }] = useHoldPayableInvoiceMutation();
    const [releasePayableInvoice, {
        isLoading: isReleasing,
        isSuccess: isReleaseSuccess,
        isError: isReleaseError,
        error: releaseError,
    }] = useReleasePayableInvoiceMutation();
    const [downloadPayableInvoices, {
        isLoading: isDownloading,
        isSuccess: isDownloadSuccess,
        isError: isDownloadError,
        error: downloadError,
    }] = useDownloadPayableInvoicesMutation();

    useEffect(() => {
        if (isHoldSuccess) {
            notification.success({
                message: 'Success',
                description: 'HOLD成功',
            })
            setSelectedRowKeys([]);
        }
        if (isHoldError) {
            notification.error({
                message: 'Error',
                description: `HOLD失败: ${holdError?.data?.error}`,
            })
        }
    }, [isHoldSuccess, isHoldError, holdError]);
    useEffect(() => {
        if (isReleaseSuccess) {
            notification.success({
                message: 'Success',
                description: 'HOLD撤回成功',
            })
            setSelectedRowKeys([]);
        }
        if (isReleaseError) {
            notification.error({
                message: 'Error',
                description: `HOLD撤回失败: ${releaseError?.data?.error}`,
            })
        }
    }, [isReleaseSuccess, isReleaseError, releaseError]);
    useEffect(() => {
        if (isDownloadSuccess) {
            notification.success({
                message: 'Success',
                description: '导出成功, 请前往后台任务管理页面获取文件',
            })
        }
        if (isDownloadError) {
            notification.error({
                message: 'Error',
                description: `导出失败: ${downloadError?.data?.error}`,
            })
        }
    }, [isDownloadSuccess, isDownloadError, downloadError]);
    const columns = [
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<Select
                    style={{
                        width: '100%',
                        textAlign: 'left',
                    }}
                    allowClear
                    placeholder="请选择"
                    options={[
                        { label: '未付款', key: '0', value: '0' },
                        { label: '已付款', key: '2', value: '2' },
                        { label: 'HOLD', key: '1', value: '1' },
                    ]}
                />
                )
            }
        },
        {
            title: 'EDI Master Number',
            dataIndex: 'edi_master_number',
            key: 'edi_master_number',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<Input
                    placeholder="请输入(支持模糊查询)"
                />
                )
            }
        },
        {
            title: 'Invoice Number',
            dataIndex: 'invoice_number',
            key: 'invoice_number',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<Input
                    placeholder="请输入(支持模糊查询)"
                />
                )
            }
        },
        {
            title: 'Account Number',
            dataIndex: 'account_number',
            key: 'account_number',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<Input
                    placeholder="请输入(支持模糊查询)"
                />
                )
            }
        },
        {
            title: 'Payment Amount',
            dataIndex: 'payment_amount',
            key: 'payment_amount',
            search: false,
        },
        {
            title: 'Invoice Date',
            dataIndex: 'invoice_date',
            key: 'invoice_date',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<RangePicker />)
            }
        },
        {
            title: 'Customer Reference',
            dataIndex: 'customer_reference',
            key: 'customer_reference',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<Input
                    placeholder="请输入(支持模糊查询)"
                />
                )
            }
        },
        {
            title: 'Payment Method Indicator',
            dataIndex: 'payment_method_indicator',
            key: 'payment_method_indicator',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<Select
                    placeholder="请选择"
                    style={{
                        textAlign: 'left',
                    }}
                    allowClear
                    options={[
                        { label: 'E', key: 'E', value: 'E' },
                    ]}
                />
                )
            }
        },
        {
            title: 'EFT Settlement Date',
            dataIndex: 'eft_settlement_date',
            key: 'eft_settlement_date',
            search: true,
            renderFormItem: (_, { type, defaultRender, ...rest }) => {
                return (<DatePicker />)
            }
        },
        {
            title: '逾期日期',
            dataIndex: 'due_date',
            key: 'due_date',
            render: renderDate,
            search: false,
        },
        {
            title: '逾期天数',
            dataIndex: 'overdue_days',
            key: 'overdue_days',
            search: false,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            search: false,
            hidden: !currUser.button_permission?.includes('payable_invoice_log'),
            hiddenInForm: !currUser.button_permission?.includes('payable_invoice_log'),
            render: (_, record) => {
                return (
                    <Space>
                        <Button
                            type="link"
                            loading={logModalLoading && loadingRecordId === record.id}
                            onClick={() => { logButtonHandler(record) }}
                        >
                            日志
                        </Button>
                    </Space>
                );
            }
        }
    ]
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
        selectedRowKeys,
    }

    const holdButtonHandler = () => {
        const formData = new FormData();
        formData.append('invoice_ids', selectedRowKeys);
        holdPayableInvoice(formData);
    }

    const releaseButtonHandler = () => {
        const formData = new FormData();
        formData.append('invoice_ids', selectedRowKeys);
        releasePayableInvoice(formData);
    }

    const logButtonHandler = (record) => {
        setLogModalLoading(true);
        setLoadingRecordId(record.id);
        axios.get(`/accounts/get-payable-invoice-operation-log/${record.id}`).then((res) => {
            setLogModalData(res.data.data);
            setLogModalOpen(true);
            setLogModalLoading(false);
        }).catch((err) => {
            console.log(err);
            setLogModalLoading(false);
            notification.error({
                message: '失败',
                description: '获取日志失败, 请稍后重试',
            })
        })
    }
    
    const paymentButtonHandler = () => {
        setPaymentModalOpen(true);
        setPaymentModalData(selectedRowKeys);
    }

    const downloadButtonHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            downloadPayableInvoices(values);
        }).catch((info) => {
            console.log('Validate Failed:', info);
        });
    }

    const paymentButtonThroughSearchHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            if (values.status !== '0') {
                notification.error({
                    message: '错误',
                    description: '批量付款必须选择未付款的状态',
                })
                return;
            }
            setPaymentThroughSearchModalOpen(true);
            setPaymentThroughSearchModalData(values);
        }).catch((info) => {
            console.log('Validate Failed:', info);
        });
    }

    return (
        <>
            <ProTable
                rowClassName={(record) => {
                    if (record.status === '未付款' && record.overdue_days >= 1) {
                        return 'long-overdue-row';
                    } else if (record.status === '未付款' && (record.overdue_days === -1 || record.overdue_days === 0)) {
                        return 'due-yd-row';
                    } else {
                        return '';
                    }
                }}
                rowKey={(record) => record.id}
                search={{
                    span: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8, xxl: 8 },
                    labelWidth: 'auto',
                    defaultCollapsed: false,
                    style: {
                        maxWidth: 'none',
                        background: token.colorFillAlter,
                        borderRadius: token.borderRadiusLG,
                        padding: 24,
                    },
                    optionRender: (searchConfig, formProps, dom) => [
                        (currUser.button_permission?.includes('payable_invoice_payment') && <Button
                            key="paymentButton"
                            type="primary"
                            onClick={() => paymentButtonThroughSearchHandler(searchConfig, formProps)}
                        >
                            批量付款
                        </Button>),
                        (currUser.button_permission?.includes('download_payable_invoice') && <Button
                            key="downloadButton"
                            type="primary"
                            loading={isDownloading}
                            onClick={() => downloadButtonHandler(searchConfig, formProps)}
                        >
                            下载数据
                        </Button>),
                        ...dom,
                    ],
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size='small' >
                            {currUser.button_permission?.includes('payable_invoice_payment') && <Button type="link" onClick={() => paymentButtonHandler()}>付款</Button>}
                            {currUser.button_permission?.includes('hold_payable_invoice') && <Button type="link" loading={isHolding} onClick={() => { holdButtonHandler() }}>HOLD</Button>}
                            {currUser.button_permission?.includes('release_payable_invoice') && <Button type="link" loading={isReleasing} onClick={() => { releaseButtonHandler() }}>HOLD撤回</Button>}
                            <Button type="link" onClick={() => { setSelectedRowKeys([]) }}>取消选择</Button>
                        </Space>
                    )
                }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={data?.results}
                request={(params) => {
                    setSearchData(params);
                }}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    total: data?.count,
                }}
                loading={isLoading || isFetching}
                scroll={{ x: 'max-content' }}
                options={{
                    reload: () => refetch(),
                }}
                toolbar={{
                    title: '',
                }}
            />
            <PayableManagementLogModal
                open={logModalOpen}
                setOpen={setLogModalOpen}
                data={logModalData}
                />
            <MakePaymentModal
                open={paymentModalOpen}
                setOpen={setPaymentModalOpen}
                data={paymentModalData}
                setSelectedRowKeys={setSelectedRowKeys}
                />
            <MakePaymentThroughSearchModal
                open={paymentThroughSearchModalOpen}
                setOpen={setPaymentThroughSearchModalOpen}
                data={paymentThroughSearchModalData}
                />
        </>
    )

}

export default PayableManagementPage;